import type { ReactElement } from 'react'

import MwMLoader from '~/components/MwMLoader'

import './styles.scss'

const SuspenseFallback = (): ReactElement => {
  return (
    <div className="suspense-fallback-component">
      <MwMLoader category="item" />
    </div>
  )
}

export default SuspenseFallback
